const noChannel = {
    major: 5,
    minor: 1,
    name: 'TV Land',
    program: 'The Twilight Zone',
};
const channels = [
    { major: 1, minor: 1, name: 'PBS', program: 'Connections' },
    { major: 2, minor: 1, name: 'CBS', program: 'The Munsters' },
    { major: 3, minor: 1, name: 'ABC', program: 'Starsky and Hutch' },
    { major: 4, minor: 1, name: 'NBC', program: 'Saturday Night Live' },
];
export class EmulatorTvTuner {
    constructor() {
        this.channelIndex = 0;
    }
    get channel() {
        var _a;
        return (_a = channels[this.channelIndex]) !== null && _a !== void 0 ? _a : noChannel;
    }
    channelDown() {
        this.channelIndex--;
        if (this.channelIndex < 0)
            this.channelIndex = channels.length - 1;
    }
    channelSet(major, minor) {
        for (let i = 0; i < channels.length; i++) {
            const ch = channels[i];
            if (ch.major === major && (minor === undefined || ch.minor === minor)) {
                this.channelIndex = i;
                return;
            }
            this.channelIndex = -1; // no channel
        }
    }
    channelUp() {
        this.channelIndex++;
        if (this.channelIndex >= channels.length)
            this.channelIndex = 0;
    }
}
